import Barba from 'barba.js'
import setNav from '../setnav.js';
import imgLoad from '../imgload.js';
import nav from '../nav.js';
import sequence from '../sequence.js';
import itemHover from '../item-hover.js';

const loaderElement = document.querySelector(".o-loading");

var FadeTransition = Barba.BaseTransition.extend({
  loader: loaderElement,
  start: function() {
    /**
     * This function is automatically called as soon the Transition starts
     * this.newContainerLoading is a Promise for the loading of the new container
     * (Barba.js also comes with an handy Promise polyfill!)
     */

    // As soon the loading is finished and the old page is faded out, let's fade the new page
    Promise
      .all([this.newContainerLoading, this.LoadingIn()])
      .then(this.LoadingOut.bind(this));
  },


  /* Fired First */
  LoadingIn: function() {

    Barba.scrollToTheTop();
    $('body').addClass('loading');
    /**
     * this.oldContainer is the HTMLElement of the old Container
     */

     //Setup Mobile Function

    var screenWidth = window.innerWidth;//$window.innerWidth;

    if (screenWidth < 768){
      //For mobile specific transitions create isMobile function
      //isMobile();
    }else{
    }

    //currently a simple loading screen
    // this.loader.classList.remove('js-hidden');
    // this.loader.classList.add('js-visible');

    const _this = this;

    return new Promise(function(resolve, reject) {
      $(_this.oldContainer).animate({opacity: 0}, 400, () => {
        setTimeout(function(){
          resolve();
        }, 400);
      });
    });

    /* Fade out old container */
    //return $(this.oldContainer).animate({opacity: 0}, 750).promise();

  },

  /* Fired Last */
  LoadingOut: function() {
    /**
     * this.newContainer is the HTMLElement of the new Container
     * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
     * Please note, newContainer is available just after newContainerLoading is resolved!
     */

      /**
       * Do not forget to call .done() as soon your transition is finished!
       * .done() will automatically remove from the DOM the old Container
       */


        var _this = this;

        const $el = $(this.newContainer);

        $(this.oldContainer).hide();

        const currentPage = Barba.HistoryManager.currentStatus();
        const prevPage = Barba.HistoryManager.prevStatus();
        $('body').removeClass(`template-${prevPage.namespace}`);
        $('body').addClass(`template-${currentPage.namespace}`);

        // this.oldContainer.cssText = "display: none";
        // this.newContainer.cssText = "visibility: 'visible'; opacity: 1;";
        //this.newContainer.classList.add('js-current');


        // FadeTransition.loader.classList.remove('js-visible');
        // FadeTransition.loader.classList.add('js-hiding');
        imgLoad();
        setNav();
        itemHover();
        //nav();
        setTimeout(function(){ $('body').removeClass('loading'); }, 600);

        $el.css({
        visibility: 'visible',
        opacity: 0
        });

        $el.delay(400).animate({ opacity: 1 }, 400, () => {
            _this.done();
            sequence();
        });

        // setTimeout(function(){
        //   FadeTransition.loader.classList.remove('js-hiding');
        //   FadeTransition.loader.classList.add('js-hidden');
        // }, 1000);

        //_this.done();
    }
});
export default FadeTransition;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbatransitions/fade.js